module.exports = __webpack_public_path__ + "a3c581055f4a957088ce6403c561ac57.svg";